'use strict';

class OperationProcedureController {
  /* @ngInject */
  constructor(OperationProceduresService, $scope, $state) {
    Object.assign(this, {
      OperationProceduresService,
      $scope,
      $state
    });
  }
}

export { OperationProcedureController as default };
